import Button from "Components/shared/button";
import FormControl from "Components/shared/control";
import { InputWithAdornment, KeyInput } from "Components/shared/inputs";
import Select from "Components/shared/select";
import Text from "Components/shared/text";
import React, { useEffect, useMemo, useRef, useState } from "react";
import AuthCodeInput from "./AuthCodeInput";
import Back from "./Back";
import styles from "./registeration.module.css";
import phoneCodes from "utils/constants/countryphone";
import {
  sendVerificationAction,
  useSendVerificationAction,
  useVerifyPhoneAction,
  verifyPhoneAction,
} from "services/authService";
import { pad } from "utils/stringServices";
import { CircularProgress } from "Components/shared/loaders";
import { ErrorModal } from "Components/shared/successful/ErrorModal";

const StageThree = ({
  onNext,
  onPrev,
  values,
  errors,
  touched,
  handleChange,
  handleUpdate,
  setValues,
}) => {
  const [subStage, setSubStage] = useState(0);
  const [isLoading, setIsLoading] = useState(false)
  const [errorModal, setErrorModal] = useState("");
  

  const sendVerificationHandler = async () => {
    setIsLoading(true);
    const body = {
      phone: values.countryCode + parseInt(values.phoneNo),
    };
    let resp;
    try{
      setErrorModal("")
       resp =  await sendVerificationAction(body.phone);
      if(resp.status === 201){
        setSubStage(1);
      }
    }
    catch(err){
      setErrorModal(err.message);
    }
    finally{
      setIsLoading(false);
    }
    console.log(resp);

    
  };

  let renderEl = (
    <>
    <SubStageOne
      onPrev={onPrev}
      sendVerificationHandler={sendVerificationHandler}
      values={values}
      handleUpdate={handleUpdate}
      errors={errors}
      touched={touched}
      setValues={setValues}
      isLoading={isLoading}
    />
    <ErrorModal setErrorModal={setErrorModal} message={errorModal} openModal={!!errorModal} />
    </>

  );
  if (subStage === 1) {
    renderEl = (
      <SubStageTwo
        setSubStage={setSubStage}
        onNext={onNext}
        handleChange={handleChange}
        handleUpdate={handleUpdate}
        errors={errors}
        touched={touched}
        values={values}
        
      />
    );
  }
  return <div className={styles.StageThree}>{renderEl}</div>;
};

const SubStageOne = ({
  onPrev,
  sendVerificationHandler,
  isLoading,
  values,
  errors,
  touched,
  handleUpdate,
  setValues,
}) => {
  const selectedCountry = useMemo(
    () => phoneCodes.find((code) => code.iso == values.country),
    [values.country]
  );
  useEffect(() => {
    if (selectedCountry) {
      setValues((prev) => ({
        ...prev,
        countryCode: selectedCountry.code,
      }));
    }
  }, [selectedCountry]);

  return (
    <>
      <Back onClick={onPrev} />
      <Text
        className={styles.Text}
        variant="xl"
        color="primary"
        style={{ width: "420px" }}
      >
        Verify your phone number with a code
      </Text>
      <FormControl fullWidth label="Phone Number" style={{ marginTop: "25px" }}>
        <div className="row-start w-full" style={{ gap: "1rem" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              minWidth: "0px",
              maxWidth: "25%",
              gap: "6px",
            }}
          >
            <Select
              options={phoneCodes}
              style={{ width: "100%" }}
              disabled={!!selectedCountry}
              name="countryCode"
              optionsValue={(option) => option.code}
              optionsText={(option) => `+${option.code}`}
              {...handleUpdate()}
              value={
                !!selectedCountry ? selectedCountry.code : values.countryCode
              }
            />
            {errors.phoneNo && touched.phoneNo && errors.phoneNo && (
              <small className="errorInput" style={{ opacity: 0 }}>
                {errors.phoneNo && touched.phoneNo && errors.phoneNo}
              </small>
            )}
          </div>

          <InputWithAdornment
            style={{ minWidth: "0", width: "75%" }}
            placeholder="Enter your phone number"
            name="phoneNo"
            value={values.phoneNo}
            error={errors.phoneNo && touched.phoneNo && errors.phoneNo}
            {...handleUpdate()}
          />
        </div>
      </FormControl>
      <FormControl fullWidth>
        <Button
          label="Send verification code"
          onClick={sendVerificationHandler}
          disabled={!!errors.phoneNo}
          loading={isLoading}
        />
      </FormControl>
    </>
  );
};

const SubStageTwo = ({
  onNext,
  setSubStage,
  values,
  errors,
  handleChange,
  touched,
  updateHandler,
}) => {
  const [time, setTime] = useState(1000 * 10 * 60);
  const [isResending, setIsResending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState("");

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime((prev) => {
        if (prev < 1000) {
          return prev;
        }
        return prev - 1000;
      });
    }, 1000);
    return () => {
      clearInterval(timerId);
    };
  }, []);


  const onResend = async () => {
    setIsResending(true);
    const body = {
      phone: values.countryCode + parseInt(values.phoneNo),
    };
    
    try{
      const resp = await sendVerificationAction(body.phone);
      if(resp.status === 201){
        setTime(1000 * 10 * 60);
      }
      console.log(resp)
    }
    catch(err){
      console.log(err)
    }
    finally{
      setIsResending(false);
    }
    ;
  };

  const verifyCodeHandler = async () => {
    setIsLoading(true)
    const body = {
      email: values.email,
      phone: values.countryCode + parseInt(values.phoneNo),
      code: values.code,
    };
    try{
      setErrorModal("");
      const {data:{status, message, data}} = await verifyPhoneAction(body);
      if(status === "Ok"){
        onNext?.()
      }
      
    }
    catch(err){
      setErrorModal(err.message)
    }
    finally{
      setIsLoading(false);
    }
    

    
  };
  return (
    <>
      <Back onClick={() => setSubStage(0)} />
      <Text
        className={styles.Text}
        variant="xl"
        color="primary"
        style={{ width: "400px" }}
      >
        Enter the 6-digit code
      </Text>
      <Text color="secondary" variant="md" style={{ paddingLeft: "20px" }}>
        We sent it to {"  "}
        <Text
          tag="span"
          color="primary"
        >{`  +${values.countryCode} ${values.phoneNo}`}</Text>
      </Text>
      <FormControl
        fullWidth
        label="Type your 6-digit security code here:"
        style={{ marginTop: "25px" }}
      >
        <AuthCodeInput
          onChange={(text) =>
            handleChange({ target: { name: "code", value: text } })
          }
          numberOfChar={6}
          fullWidth
        />
      </FormControl>
      <FormControl fullWidth>
        <Button
          label="Submit"
          onClick={verifyCodeHandler}
          disabled={!!errors.code}
          fullWidth
          loading={isLoading}
        />
      </FormControl>
      <div
        className="w-full row-start"
        style={{
          marginTop: "15px",
          justifyContent: "space-between",
          padding: "0 20px",
        }}
      >
        <Text color="secondary" variant="md">
          Not recieved code?{" "}
          <Text
            className="hover:link"
            tag="span"
            style={{ color: "var(--secondary-color)" }}
            onClick={onResend}
          >
           {isResending? <span style={{display:"inline-flex", paddingLeft:"8px"}}><CircularProgress color="var(--secondary-color)" size="16px" /></span>: "Resend"} 
          </Text>
        </Text>
        <Text style={{ color: "var(--secondary-color)" }}>
          {pad(parseInt(time / 1000 / 60), 2)}:
          {pad(parseInt((time / 1000) % 60), 2)}
        </Text>
      </div>
      <ErrorModal message={errorModal} openModal={!!errorModal} setErrorModal={setErrorModal} />
    </>
  );
};
export default StageThree;
